import { useMemo } from 'react';
import useVirtualizedOptions from '@/storybook/components/FormCollection/hooks/useVirtualizedOptions';
import { SelectItem } from '@/types/ui';

export type UseFloatingLabelVirtualizedOptionsParams<T> = {
  selectedOptions?: SelectItem<T>[];
  notSelectedOptions?: SelectItem<T>[];
  categoriesToDisplay: Array<{ category: string; index: number }>;
  noCategoryLabel: string;
};

export function useFloatingLabelVirtualizedOptions<T>({
  selectedOptions = [],
  notSelectedOptions = [],
  categoriesToDisplay,
  noCategoryLabel,
}: UseFloatingLabelVirtualizedOptionsParams<T>) {
  const needsDivider = selectedOptions.length > 0 && notSelectedOptions.length > 0;

  const hasCategorizedOptions = useMemo(
    () => notSelectedOptions.some(opt => opt?.category != null),
    [notSelectedOptions],
  );

  const { virtualizedList, parentRef } = useVirtualizedOptions<T>({
    selectedOptions,
    notSelectedOptions,
    hasCategorizedOptions,
    categoriesToDisplay,
    includeDivider: needsDivider,
    noCategoryLabel,
  });

  return {
    virtualizedList,
    parentRef,
    selectedOptions,
    notSelectedOptions,
  };
}
